import Vue from "vue";
import VueRouter from "vue-router";
import layout from "@/views/layout.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: layout,
    children: [
      {
        path: "manager",
        name: "manager",
        component: () => import("@/views/manager.vue"),
        children: [
          {
            path: "shop_page_list",
            name: "shop_page_list",
            component: () => import("@/views/shop_page_list.vue"),
          },
          {
            path: "shop_page_form",
            name: "shop_page_form",
            component: () => import("@/views/shop_page_form.vue"),
            props: (route) => {
              return route.query;
            },
          },
          {
            path: "shop_page_shop",
            name: "shop_page_shop",
            component: () => import("@/views/shop_page_shop.vue"),
            props: (route) => {
              return route.query;
            },
          },
          {
            path: "part_form",
            name: "part_form",
            component: () => import("@/views/part_form.vue"),
            props: (route) => {
              return route.query;
            },
          },
        ],
      },
      {
        path: "/do",
        name: "do",
        component: () => import("@/views/do.vue"),
        children: [
          {
            path: "user",
            name: "user",
            component: () => import("@/views/user.vue"),
            props: (route) => {
              return route.query;
            },
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
